import { render, staticRenderFns } from "./adminPage.vue?vue&type=template&id=2fe8dfc4&"
import script from "./adminPage.vue?vue&type=script&lang=js&"
export * from "./adminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports